import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    posts: [],
    page: 1,
    hasMore: true,
    scrollPosition: 0,
};

const feedSlice = createSlice({
    name: "feed",
    initialState,
    reducers: {
        setFeeds: (state, action) => {
            // Append unique posts only
            const newPosts = action.payload.filter(
                (newPost) => !state.posts.find((p) => p._id === newPost._id)
            );
            state.posts = [...state.posts, ...newPosts];
        },
        resetFeeds: (state, action) => {
            state.posts = action.payload;
            state.page = 1;
            state.hasMore = true;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setHasMore: (state, action) => {
            state.hasMore = action.payload;
        },
        setScrollPosition: (state, action) => {
            state.scrollPosition = action.payload;
        },
    },
});

export const { setFeeds, resetFeeds, setPage, setHasMore, setScrollPosition } = feedSlice.actions;
export default feedSlice.reducer;